import type {SVGProps} from 'react'
const BellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 1000 1000"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M500 100v75M250 425a250 250 0 0 1 500 0v150c0 75 25 125 75 175H175c50-50 75-100 75-175V425ZM400 800a100 100 0 0 0 200 0"
      fill="none"
      stroke="currentColor"
      strokeWidth={50}
      strokeLinecap="butt"
      strokeLinejoin="miter"
    />
  </svg>
)
export {BellIcon}
